module.exports = __webpack_public_path__ + "/img/Header-Male-Straight-Labeled-6MtDDL.svg";